import CallList from "../Views/Call/CallList.vue";
import {MODULES} from "../Constants/modules.js";

export const callRoutes = [
    {
        path: "/calls",
        name: "calls.list",
        component: CallList,
        meta: {
            module: MODULES.CALLS,
            menu: {
                parent: 'calls',
                child: null
            },
            breadcrumb: {
                title: "Appels",
                nav: {
                    all: {
                        active: "Tous les appels",
                        inactive: null
                    }
                }
            }
        },
    }
];
